(function () {
  const STORAGE_KEY = 'ifwl_wishlist';
  const customer = window.shopifyCustomer || {};

  // ─────────────────────────────────────────
  // localStorage helpers
  // ─────────────────────────────────────────
  function getList() {
    return JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
  }

  function saveList(list) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
    updateBadge();
  }

  // ─────────────────────────────────────────
  // Header badge
  // ─────────────────────────────────────────
  function updateBadge() {
    const list = getList();
    const badge = document.querySelector('.wishlist-count');
    if (!badge) return;
    if (list.length > 0) {
      badge.textContent = list.length;
      badge.style.display = 'inline-flex';
    } else {
      badge.style.display = 'none';
    }
  }

  // ─────────────────────────────────────────
  // Login prompt modal
  // ─────────────────────────────────────────
  function showWishlistLoginPrompt(productId) {
    localStorage.setItem('ifwl_pending_wishlist', productId);

    const modal = document.createElement('div');
    modal.id = 'wishlist-login-modal';
    modal.innerHTML = `
      <div class="wl-modal__backdrop"></div>
      <div class="wl-modal__box" role="dialog" aria-modal="true" aria-labelledby="wl-modal-title">
        <button class="wl-modal__close" aria-label="Close">✕</button>
        <div class="wl-modal__icon">♡</div>
        <h2 class="wl-modal__title" id="wl-modal-title">Save to Wishlist</h2>
        <p class="wl-modal__text">Sign in or create an account to save your favourites and access them from any device.</p>
        <div class="wl-modal__actions">
          <a href="/account/login?return_url=/pages/wishlist" class="wl-modal__btn wl-modal__btn--primary">Sign In</a>
          <a href="/account/register?return_url=/pages/wishlist" class="wl-modal__btn wl-modal__btn--secondary">Create Account</a>
        </div>
        <p class="wl-modal__guest">
          <button class="wl-modal__skip">Continue as guest</button>
        </p>
      </div>
    `;

    document.body.appendChild(modal);
    document.body.style.overflow = 'hidden';

    function closeModal() {
      modal.remove();
      document.body.style.overflow = '';
    }

    modal.querySelector('.wl-modal__close').addEventListener('click', closeModal);
    modal.querySelector('.wl-modal__backdrop').addEventListener('click', closeModal);

    modal.querySelector('.wl-modal__skip').addEventListener('click', () => {
      closeModal();
      // Save to localStorage as guest
      let local = getList();
      if (!local.includes(String(productId))) {
        local.push(String(productId));
        saveList(local);
        // Update button state
        const btn = document.querySelector(`.wishlist-btn[data-product-id="${productId}"]`);
        if (btn) {
          btn.querySelector('.wishlist-icon--empty').style.display = 'none';
          btn.querySelector('.wishlist-icon--filled').style.display = 'inline';
          btn.classList.add('is-wishlisted');
        }
      }
    });
  }

  // ─────────────────────────────────────────
  // Wishlist buttons (product page / cards)
  // ─────────────────────────────────────────
  function initButtons() {
    const list = getList();

    document.querySelectorAll('.wishlist-btn').forEach(btn => {
      const id = String(btn.dataset.productId);
      const empty = btn.querySelector('.wishlist-icon--empty');
      const filled = btn.querySelector('.wishlist-icon--filled');

      // Set initial state
      if (list.includes(id)) {
        empty.style.display = 'none';
        filled.style.display = 'inline';
        btn.classList.add('is-wishlisted');
      }

      btn.addEventListener('click', () => {
        // Guest → show login modal
        if (!customer.loggedIn) {
          showWishlistLoginPrompt(id);
          return;
        }

        // Logged in → toggle
        let current = getList();
        if (current.includes(id)) {
          current = current.filter(i => i !== id);
          empty.style.display = 'inline';
          filled.style.display = 'none';
          btn.classList.remove('is-wishlisted');
        } else {
          current.push(id);
          empty.style.display = 'none';
          filled.style.display = 'inline';
          btn.classList.add('is-wishlisted');
        }
        saveList(current);
      });
    });
  }

  // ─────────────────────────────────────────
  // Render wishlist grid
  // Works on both /pages/wishlist and /account
  // ─────────────────────────────────────────
  async function renderWishlistPage() {
    const grid = document.getElementById('wishlist-grid');
    if (!grid) return;

    const list = getList();

    // Find empty message — works for both page templates
    const emptyMsg =
      grid.closest('.account-wishlist')?.querySelector('.account-wishlist__empty') ||
      document.querySelector('.wishlist-page__empty');

    if (list.length === 0) {
      if (emptyMsg) emptyMsg.style.display = 'block';
      return;
    }

    // Fetch product data for each saved ID
    const products = await Promise.all(
      list.map(id =>
        fetch(`/products.json?product_ids=${id}&limit=1`)
          .then(r => r.json())
          .then(data => data.products[0])
          .catch(() => null)
      )
    );

    products.filter(Boolean).forEach(product => {
      const price = (product.variants[0].price / 100).toLocaleString('en-GB', {
        style: 'currency', currency: 'GBP'
      });

      const card = document.createElement('div');
      card.className = 'wishlist-card';
      card.innerHTML = `
        <a href="/products/${product.handle}" class="wishlist-card__image-link">
          <img
            src="${product.images[0]?.src || ''}"
            alt="${product.title}"
            loading="lazy"
          >
        </a>
        <div class="wishlist-card__info">
          <a href="/products/${product.handle}" class="wishlist-card__title">${product.title}</a>
          <p class="wishlist-card__price">${price}</p>
          <div class="wishlist-card__actions">
            <a href="/products/${product.handle}" class="btn wishlist-card__btn-view">View Product</a>
            <button
              class="wishlist-card__remove"
              data-id="${product.id}"
              aria-label="Remove from wishlist">
              ✕ Remove
            </button>
          </div>
        </div>
      `;

      // Remove button
      card.querySelector('.wishlist-card__remove').addEventListener('click', (e) => {
        const removeId = String(e.currentTarget.dataset.id);
        saveList(getList().filter(i => i !== removeId));
        card.remove();
        if (document.querySelectorAll('.wishlist-card').length === 0) {
          if (emptyMsg) emptyMsg.style.display = 'block';
        }
      });

      grid.appendChild(card);
    });
  }

  // ─────────────────────────────────────────
  // Boot
  // ─────────────────────────────────────────
  document.addEventListener('DOMContentLoaded', () => {
    // Auto-save pending item after login redirect
    const pending = localStorage.getItem('ifwl_pending_wishlist');
    if (pending && customer.loggedIn) {
      localStorage.removeItem('ifwl_pending_wishlist');
      let current = getList();
      if (!current.includes(pending)) {
        current.push(pending);
        saveList(current);
      }
    }

    updateBadge();
    initButtons();
    renderWishlistPage();
  });

})();
